import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ResultsRoutingModule } from './results-routing.module';
import { ResultsComponent } from './results.component';
import { CaseResultComponent } from './case-result/case-result.component';
import { CollectAnswerComponent } from './collect-answer/collect-answer.component';
import { SharedModule } from '../shared/shared.module';
import { CollectResponseComponent } from './collect-response/collect-response.component';

@NgModule({
  declarations: [ResultsComponent, CaseResultComponent, CollectAnswerComponent, CollectResponseComponent],
  imports: [
    SharedModule,
    ResultsRoutingModule
  ]
})
export class ResultsModule { }
